import gql from 'fraql'
const statsOrdersWorkshopsQueries = {
  OVERALL_TIME_ORDERS: gql`
  query statsCooking ($dateFrom: Datetime!, $dateTo: Datetime!, $idRestPoint: Int) {
    statsCookingOrders(dateFrom: $dateFrom, dateTo: $dateTo, idRestPoint: $idRestPoint) {
      nodes {
        date,
        hours,
        diff {
          seconds,
          minutes,
          hours,
          days,
          months,
          years
        }
      }
    }
  }
  `,
  COOKED_TIME_WORKSHOPS: gql`
  query statsWorkshopsOverall($dateFrom: Datetime!, $dateTo: Datetime!, $idRestPoint: Int, $idDeliveryType: Int) {
    statsWorkshopsOverall (timeFrom: $dateFrom, timeTo: $dateTo, idRestPoint: $idRestPoint, idDeliveryType: $idDeliveryType) {
      nodes {
        datetime,
        hotWorkshop,
        coldWorkshop,
        pizzaWorkshop
      }
    }
  }
  `
}
export default statsOrdersWorkshopsQueries



// WEBPACK FOOTER //
// ./src/graphql/statsOrdersWorkshops.js